import extractErrorMessage from '../utils/extractErrorMessage';
import { authClient } from './client';

/** The full matrix plus the permission catalogue. Requires roles:read. */
export const fetchRolesAndPermissions = async () => {
  try {
    const response = await authClient.get('/admin/roles-permissions');
    return { data: response.data.data, error: null };
  } catch (error) {
    return {
      data: null,
      error: extractErrorMessage(
        error,
        'Došlo je do greške pri dobavljanju rola i permisija.',
      ),
    };
  }
};

/** What the signed-in user may do. Every signed-in user may call this. */
export const fetchMyPermissions = async () => {
  try {
    const response = await authClient.get('/admin/roles-permissions/me');
    return { data: response.data.data, error: null };
  } catch (error) {
    return {
      data: null,
      error: extractErrorMessage(error, 'Došlo je do greške pri dobavljanju permisija.'),
    };
  }
};

/** Replaces the whole permission set of one role. Requires roles:manage. */
export const updateRolePermissions = async (role, permissions) => {
  try {
    const response = await authClient.put(`/admin/roles-permissions/${role}`, { permissions });
    return { data: response.data.data, error: null };
  } catch (error) {
    return {
      data: null,
      error: extractErrorMessage(error, 'Došlo je do greške pri čuvanju permisija.'),
    };
  }
};

export const resetRolePermissions = async (role) => {
  try {
    const response = await authClient.post(`/admin/roles-permissions/${role}/reset`);
    return { data: response.data.data, error: null };
  } catch (error) {
    return {
      data: null,
      error: extractErrorMessage(error, 'Došlo je do greške pri vraćanju na podrazumevano.'),
    };
  }
};
